import { FiFileText, FiCheck, FiClock, FiMail } from "react-icons/fi";
import {
  TableRow,
  SkeletonCell,
  SkeletonPulse,
  AnalyticsCard,
  AnalyticsCardHeader,
  AnalyticsCardIcon,
  AnalyticsCardTitle,
  AnalyticsSkeletonValue,
  AnalyticsSkeletonGrid,
} from "../styles/Layoutstyle";

export const SkeletonRow = ({ columns = 8, isDarkMode }) => (
  <TableRow isDarkMode={isDarkMode}>
    {Array(columns)
      .fill()
      .map((_, index) => {
        // Define specific widths for each column based on content type
        let width;
        switch (index) {
          case 0: // Order ID
            width = "60px";
            break;
          case 1: // Status
            width = "80px";
            break;
          case 2: // EOS Status
            width = "80px";
            break;
          case 3: // Street View Required
            width = "50px";
            break;
          case 4: // Accuzip Number
            width = "80px";
            break;
          case 5: // Total
            width = "60px";
            break;
          case 6: // Street View Completed
            width = "99px";
            break;
          case 7: // Street View Completion Date
            width = "99px";
            break;
          default:
            width = "80px";
        }

        return (
          <SkeletonCell key={index} isDarkMode={isDarkMode}>
            <SkeletonPulse width={width} isDarkMode={isDarkMode} />
          </SkeletonCell>
        );
      })}
  </TableRow>
);

export const SkeletonRows = ({ count = 5, isDarkMode }) => (
  <>
    {Array(count)
      .fill()
      .map((_, index) => (
        <SkeletonRow key={index} columns={8} isDarkMode={isDarkMode} />
      ))}
  </>
);

export const AnalyticsSkeleton = ({ isDarkMode }) => (
  <AnalyticsSkeletonGrid>
    <AnalyticsCard color="#667eea" isDarkMode={isDarkMode}>
      <AnalyticsCardHeader>
        <AnalyticsCardIcon
          bgColor="rgba(102, 126, 234, 0.1)"
          iconColor="#667eea"
        >
          <FiFileText />
        </AnalyticsCardIcon>
        <AnalyticsCardTitle isDarkMode={isDarkMode}>Total Orders</AnalyticsCardTitle>
      </AnalyticsCardHeader>
      <AnalyticsSkeletonValue isDarkMode={isDarkMode} />
    </AnalyticsCard>

    <AnalyticsCard color="#4caf50" isDarkMode={isDarkMode}>
      <AnalyticsCardHeader>
        <AnalyticsCardIcon bgColor="rgba(76, 175, 80, 0.1)" iconColor="#4caf50">
          <FiCheck />
        </AnalyticsCardIcon>
        <AnalyticsCardTitle isDarkMode={isDarkMode}>Completed Orders</AnalyticsCardTitle>
      </AnalyticsCardHeader>
      <AnalyticsSkeletonValue isDarkMode={isDarkMode} />
    </AnalyticsCard>

    <AnalyticsCard color="#ff9800" isDarkMode={isDarkMode}>
      <AnalyticsCardHeader>
        <AnalyticsCardIcon bgColor="rgba(255, 152, 0, 0.1)" iconColor="#ff9800">
          <FiClock />
        </AnalyticsCardIcon>
        <AnalyticsCardTitle isDarkMode={isDarkMode}>Processing Orders</AnalyticsCardTitle>
      </AnalyticsCardHeader>
      <AnalyticsSkeletonValue isDarkMode={isDarkMode} />
    </AnalyticsCard>

    <AnalyticsCard color="#03a9f4" isDarkMode={isDarkMode}>
      <AnalyticsCardHeader>
        <AnalyticsCardIcon bgColor="rgba(3, 169, 244, 0.1)" iconColor="#03a9f4">
          <FiMail />
        </AnalyticsCardIcon>
        <AnalyticsCardTitle isDarkMode={isDarkMode}>Pending Orders</AnalyticsCardTitle>
      </AnalyticsCardHeader>
      <AnalyticsSkeletonValue isDarkMode={isDarkMode} />
    </AnalyticsCard>
  </AnalyticsSkeletonGrid>
);

// Export all skeleton components as default
export default {
  SkeletonRow,
  SkeletonRows,
  AnalyticsSkeleton,
};
